import request from "./request";
import { IRequest } from "@/shared/types/request";
import { IUser } from "@/shared/types/permissions";

interface IFormData {
  [key: string]: FormDataEntryValue;
}

export const getUser = () =>
  request.get<never, IRequest<IUser[]>>("/permissions/users");

export const getRoles = () => request.get("/permissions/roles");

export const deleteRoles = (id: string) =>
  request.post<never, IRequest<IUser>>(`/permissions/users/${id}/delete-roles
  `);

export const updateUser = ({ id, field }: { id: string; field: IFormData }) =>
  request.post<never, IRequest<IUser>>(
    `/permissions/users/${id}/assign-roles`,
    field
  );

export const getUserRoles = (id: string) =>
  request.get(`/permissions/users/${id}/roles
`);
